export default [
  {
    path: 'subjectGroups',
    component: () => import('@/views/subjectGroup/SubjectGroups.vue'),
    name: 'SubjectGroups',
    meta: {
      title: 'Quản lý bộ môn',
      auth: true,
      permission: 'view-subjectGroup-list',
    },
  },
  {
    path: 'academics',
    component: () => import('@/views/academicLevel/Academics.vue'),
    name: 'Academics',
    meta: {
      title: 'Bộ môn',
      auth: true,
      permission: 'config-academic-level',
    },
  },
  {
    path: 'grades',
    component: () => import('@/views/grade/Grades.vue'),
    name: 'Grade',
    meta: {
      title: 'Danh sách học phần',
      auth: true,
    },
  },
  {
    path: 'grades/:id',
    component: () => import('@/views/grade/GradeDetail.vue'),
    name: 'Chi tiết phần',
    meta: {
      title: 'Chi tiết học phần',
      auth: true,
    },
  },
  {
    path: 'subjects',
    component: () => import('@/views/subject/Subjects.vue'),
    name: 'Subjects',
    meta: {
      title: 'Môn Học',
      auth: true,
      permission: 'view-subject-list',
    },
  },
  {
    path: 'subject/:id',
    component: () => import('@/views/subject/Subject.vue'),
    name: 'Subject',
    meta: {
      title: 'Môn Học',
      auth: true,
    },
  },
  {
    path: 'schedule',
    name: 'schedule',
    component: () => import('@/views/schedule/Schedule.vue'),
    meta: {
      title: 'Thời Khóa Biểu',
      auth: true,
    },
  },
  {
    path: 'classes',
    component: () => import('@/views/class/Classes'),
    name: 'Lớp Học',
    meta: {
      title: 'Danh sách lớp học',
      auth: true,
      permission: 'view-class-list',
    },
  },
  {
    path: 'time-table-config',
    component: () => import('@/views/timetable/TimeTable.vue'),
    name: 'timetable',
    meta: {
      title: 'Cấu Hình Thời Khóa Biểu',
      auth: true,
      permission: 'view-class-schedule',
    },
  },
  {
    path: 'class/:id',
    name: 'class',
    component: () => import('@/views/class/ClassDetail'),
    meta: {
      title: 'Lớp học',
      auth: true,
    },
  },
  {
    path: '/education-programs',
    component: () => import('@/views/education-programs/index.vue'),
    name: 'education-programs',
    meta: {
      title: 'Chương trình đào tạo',
      auth: true,
    },
  },
  {
    path: '/holiday',
    component: () => import('@/views/timetable/HolidayConfig.vue'),
    name: 'holiday',
    meta: {
      title: 'Cấu Hình Ngày Nghỉ',
      auth: true,
    },
  },
]
